export default {"src":"/sg/_next/static/media/ChapelTrain.1c2bebbe.svg","height":150,"width":110,"blurWidth":0,"blurHeight":0};